export const MaritalStatus = [
  'Single',
  'Married',
  'Widowed',
  'Divorced'
];
